import React, {PropTypes} from 'react'
import Table from 'react-bootstrap/lib/Table'

import ListSubjectItem from './list-subject-item'

const ListSubjects = ({items, isShow, onDelete}) => (
  <Table condensed hover className="payment">
    <thead>
      <tr>
        <th width="10">&nbsp;</th>
        <th>Code</th>
        <th>Description</th>
        <th>Curriculum</th>
        <th className="text-right">Units</th>
        <th className="text-right">Enrolled</th>
      </tr>
    </thead>
    <tbody>
      {items.map((item, k) => (
        <ListSubjectItem
          key={k}
          k={k}
          item={item}
          isShow={isShow}
          onDelete={onDelete}
        />
      ))}
    </tbody>
  </Table>
)

ListSubjects.propTypes = {
  items: PropTypes.object,
  isShow: PropTypes.bool,
  onDelete: PropTypes.func,
}

export default ListSubjects



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/list-subjects.js